var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoveZone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.006,
    cy: 16.006,
    r: 14.946,
    fill: "#7f7f7f",
    stroke: "#333",
    strokeWidth: 2.1087
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.1213 0 0 6.1213 34.839 -8.185)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8436 2.2077-1e-7 3.4912-0.46483 1e-7 1e-7 -3.4912zm-1.978 1.5132h3.4912v0.46483l-3.4912-1e-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-0.92719 3.9533-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1,1)",
    d: "m5.2237 3.9533-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 -1 .99996 0 -5.6017 -.82508)",
    d: "m-2.6304 2.5257-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90,-2.7221,4.4039)",
    d: "m-1.0263 4.7577-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveZone);
export default __webpack_public_path__ + "static/media/move_zone.347e3f0ee381f95d7aa6297cbd9e4c5d.svg";
export { ForwardRef as ReactComponent };